<form (submit)="registerIrrigation($event)" class="irrigation-form">
  <div class="form-row">
    <mat-form-field class="form-field" data-test="irrigation-irrigationDialog-startDate">
      <mat-label>{{ 'irrigation.startDate' | translate }}</mat-label>
      <input
        matInput
        [formField]="registerIrrigationForm.startDate"
        [matDatepicker]="startDatePicker"
        [placeholder]="'irrigation.startDate' | translate"
      />
      <mat-datepicker-toggle matSuffix [for]="startDatePicker" [disabled]="readOnly()" />
      <mat-datepicker #startDatePicker />
    </mat-form-field>

    <mat-form-field class="form-field" data-test="irrigation-irrigationDialog-startTime">
      <mat-label>{{ 'irrigation.startTime' | translate }}</mat-label>
      <mat-select [formField]="registerIrrigationForm.startHour">
        @for (hour of hours; track hour) {
          <mat-option [value]="hour"> {{ hour | number: '2.0-0' }}:00</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field class="form-field" data-test="irrigation-irrigationDialog-endDate">
      <mat-label>{{ 'irrigation.endDate' | translate }}</mat-label>
      <input
        matInput
        [formField]="registerIrrigationForm.endDate"
        [matDatepicker]="endDatePicker"
        [placeholder]="'irrigation.endDate' | translate"
      />
      <mat-datepicker-toggle matSuffix [for]="endDatePicker" [disabled]="readOnly()" />
      <mat-datepicker #endDatePicker />
    </mat-form-field>

    <mat-form-field class="form-field" data-test="irrigation-irrigationDialog-endTime">
      <mat-label>{{ 'irrigation.endTime' | translate }}</mat-label>
      <mat-select [formField]="registerIrrigationForm.endHour">
        @for (hour of hours; track hour) {
          <mat-option [value]="hour"> {{ hour | number: '2.0-0' }}:00</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  @if (hasInvalidDateRange()) {
    <div class="date-range-error">
      <mat-icon>error_outline</mat-icon>
      {{ 'irrigation.startDateAfterEndDate' | translate }}
    </div>
  }
  @if (hasInvalidDateTimeRange()) {
    <div class="date-range-error">
      <mat-icon>error_outline</mat-icon>
      {{ 'irrigation.startTimeGreaterThanEndTime' | translate }}
    </div>
  }

  <div class="form-row amount-row">
    <mat-form-field class="form-field" data-test="irrigation-irrigationDialog-amount" subscriptSizing="dynamic">
      <mat-label>{{ 'irrigation.amount' | translate }}</mat-label>
      <input
        matInput
        type="number"
        [formField]="registerIrrigationForm.amountInMillimeters"
        [step]="0.01"
        autocomplete="off"
        data-test="irrigation-amount"
      />
    </mat-form-field>
  </div>

  <div class="form-row">
    <fieldset class="irrigation-type-fieldset" data-test="irrigation-irrigationDialog-type">
      <legend class="irrigation-type-legend">
        {{ 'irrigation.type' | translate }}
      </legend>
      <mat-radio-group [formField]="registerIrrigationForm.type" class="radio-group">
        @for (type of irrigationTypes; track type) {
          <mat-radio-button [value]="type" color="primary">
            {{ type | irrigationType | translate }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </fieldset>
  </div>

  <div class="form-actions">
    <span
      [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate"
      [matTooltipDisabled]="!showPastYearReadonlyTooltip()"
    >
      <button
        [disabled]="isSubmitDisabled()"
        mat-flat-button
        color="accent"
        data-test="done-adding-product"
        type="submit"
      >
        <mat-icon>add</mat-icon>
        {{ 'irrigation.add' | translate }}
      </button>
    </span>
  </div>
</form>
